import TemplateDashboard from '../app/templates/TemplateDashboard'
import DashboardResume from '../app/pages/DashboardResume'
import DashboardStatement from '../app/pages/DashboardStatement'
import DashboardStatementPartner from '../app/pages/DashboardStatementPartner'
import DashboardInvoice from '../app/pages/DashboardInvoice'
import DashboardIdentifiers from '../app/pages/DashboardIdentifiers'
import DashboardIdentifiersPartner from '../app/pages/DashboardIdentifiersPartner'
import DashboardIdentifiersHistory from '../app/pages/DashboardIdentifiersHistory'
import DashboardIdentifiersRequests from '../app/pages/DashboardIdentifiersRequests'
import DashboardRechargeHistory from '../app/pages/DashboardRechargeHistory'
import DashboardHowToInstall from 'app/pages/DashboardHowToInstall'
import PlanData from '../app/pages/PlanData'
import InvoiceDetails from '../app/pages/InvoiceDetails'

export default {
  path: '/minha-veloe/:id',
  component: TemplateDashboard,
  routes: [
    {
      exact: true,
      path: '/minha-veloe/:id/resumo/',
      component: DashboardResume
    },
    {
      exact: true,
      path: '/minha-veloe/:id/extrato',
      component: DashboardStatement
    },
    {
      exact: true,
      path: '/minha-veloe/:id/extrato-parceiro',
      component: DashboardStatementPartner
    },
    {
      exact: true,
      path: '/minha-veloe/:id/fatura',
      component: DashboardInvoice
    },
    {
      exact: true,
      path: '/minha-veloe/:id/fatura/:fatura',
      component: InvoiceDetails
    },
    {
      exact: true,
      path: '/minha-veloe/:id/fatura/:fatura/:qtdtransacoes',
      component: InvoiceDetails
    },
    {
      exact: true,
      path: '/minha-veloe/:id/historico-de-recarga',
      component: DashboardRechargeHistory
    },
    {
      exact: true,
      path: '/minha-veloe/:id/identificadores',
      component: DashboardIdentifiers
    },
    {
      exact: true,
      path: '/minha-veloe/:id/identificadores-parceiro',
      component: DashboardIdentifiersPartner
    },
    {
      exact: true,
      path: '/minha-veloe/:id/identificadores/historico-tag',
      component: DashboardIdentifiersHistory
    },
    {
      exact: true,
      path: '/minha-veloe/:id/instalacao',
      component: DashboardHowToInstall
    },
    {
      exact: true,
      path: '/minha-veloe/:id/dados-do-plano',
      component: PlanData
    },
    {
      exact: true,
      path: '/minha-veloe/:id/identificadores/nova-tag',
      component: DashboardIdentifiersRequests
    }
  ]
}



// WEBPACK FOOTER //
// ./src/routes/dashboard.js